import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useEffect, useLayoutEffect, useState} from "react";
import {permissionObj} from "../../../../../Helpers/permission";
import {GetAllDepartments} from "../../../../../reduxToolkit/DocumentPanel/DocumentPanelApi";
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {useNavigate} from "react-router-dom";
import {TABLES} from "../../../../../Apis/Tables";

const UserDocPanelApp = () =>{
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [addDocumentModal, setAddDocumentModal] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [selectDocForDelete, setSelectDocForDelete] = useState([]);
    const [deleteDocShow, setDeleteDocShow] = useState(false);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [modified, setModified] = useState(false);
    const [action, setAction] = useState(null);
    const [item, setItem] = useState(null);

    const handleStepChange = (step) => {
        setModified(true);
        setActiveStep(step);
    };

    useLayoutEffect(() => {
        let steps = [];
        if (DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_READ))steps.push(t("employees"));

        if (permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_READ)) {
            setActiveStep(0);
        }

        setSteps(steps);
    }, [permission, t]);

    const resetAllCheckboxes = () => {
        const checkboxes = document.querySelectorAll('.checkbox');
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });
    };

    useEffect(() => {
        resetAllCheckboxes();
        setSelectDocForDelete([]);
        setIsAllChecked(false);
    }, [activeStep]);

    useEffect(() => {
        dispatch(GetAllDepartments());
    }, []);

    const deleteSelectedDocuments = (deleteItem) => {
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName: TABLES.EMPLOYEE_DOCUMENT_COMPANY, body })).then(
                ({
                     payload: {
                         data: { success },
                     },
                 }) => {
                    if (success === true) {
                        setModified(true);
                        setSelectDocForDelete([]);
                        setIsAllChecked(false);
                    }
                },
            );
        }
    };

    const handleAction = (item, action) => {
        setItem(item);
        setAction(action);
        setAddDocumentModal(true);
    }

    return {
        t,
        DEV,
        navigate,
        permission,
        steps,
        activeStep,
        setActiveStep,
        addDocumentModal,
        setAddDocumentModal,
        isAllChecked,
        setIsAllChecked,
        selectDocForDelete,
        deleteDocShow,
        setDeleteDocShow,
        setSelectDocForDelete,
        modified,
        setModified,
        action,
        setAction,
        item,
        setItem,
        handleStepChange,
        deleteSelectedDocuments,
        handleAction
    }
}

export default UserDocPanelApp;
